import { useState, useEffect } from "react";
import { getTagById } from "@/services/tagsApi";
import { Tag as ApiTag } from "@/types/api";

interface Tag {
  id: string;
  name: string;
  description: string | null;
  type: string;
  color: string;
  icon?: string;
  created_at: string;
  criteria: any;
}

interface ResourceCounts {
  devices: number;
  profiles: number;
  applications: number;
  configurations: number;
  patchPolicies: number;
  users: number;
}

function mapApiTag(apiTag: ApiTag): Tag {
  return {
    id: apiTag.tagId || '',
    name: apiTag.tagName,
    description: apiTag.description || null,
    type: 'static',
    color: apiTag.color || '#3B82F6',
    created_at: apiTag.createdAt || new Date().toISOString(),
    criteria: null,
  };
}

export const useTagDetail = (tagId: string) => {
  const [tag, setTag] = useState<Tag | null>(null);
  const [resourceCounts, setResourceCounts] = useState<ResourceCounts>({
    devices: 0, profiles: 0, applications: 0, configurations: 0, patchPolicies: 0, users: 0
  });
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTagDetail = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const apiTag = await getTagById(tagId);
      setTag(mapApiTag(apiTag));
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (tagId) fetchTagDetail();
  }, [tagId]);

  return { tag, resourceCounts, isLoading, error, refetch: fetchTagDetail };
};
